module.exports = __webpack_public_path__ + "static/media/ImportIntegration.41514263.png";